import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { useMobileMediaQuery } from '@/hooks/useMobileMediaQuery';

import TestimonialTile from '../TestimonialTile/TestimonialTile';
import {
  Chip,
  Headline,
  SliderWrapper,
  Subline,
  Wrapper,
} from './Testimonials.style';

const Testimonials = ({ chip, headline, subline, cards }) => {
  const isMobile = useMobileMediaQuery();

  const sliderOptions = {
    dots: true,
    arrows: false,
    rows: 1,
    infinite: true,
    speed: 1000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    ...(!isMobile && { variableWidth: true }),
  };

  return (
    <Wrapper data-test-subject="testimonial-wrapper">
      {chip && (
        <Chip size="small" uppercase>
          {chip}
        </Chip>
      )}
      <Grid container>
        <Grid item md={10}>
          <Headline variant="h2Redesign" component="h2" color="primary.dark">
            {headline}
          </Headline>
        </Grid>
        {subline && (
          <Grid item md={10}>
            <Subline>{subline}</Subline>
          </Grid>
        )}
      </Grid>
      <SliderWrapper>
        <Slider {...sliderOptions}>
          {cards.map(
            ({ id, title, text, logo, image, customerName, jobTitle }) => (
              <TestimonialTile
                key={id}
                title={title}
                image={image}
                text={text}
                logo={logo}
                customerName={customerName}
                jobTitle={jobTitle}
              />
            )
          )}
        </Slider>
      </SliderWrapper>
    </Wrapper>
  );
};

Testimonials.propTypes = {
  chip: PropTypes.string,
  headline: PropTypes.string.isRequired,
  subline: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string,
      text: PropTypes.string,
      logo: PropTypes.shape({
        data: PropTypes.shape({
          attributes: PropTypes.shape({
            url: PropTypes.string.isRequired,
          }),
        }),
      }).isRequired,
      image: PropTypes.shape({
        attributes: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }).isRequired,
      }),
      customerName: PropTypes.string,
      jobTitle: PropTypes.string,
    })
  ).isRequired,
};

export default Testimonials;
